// widget.slice.ts (Redux Toolkit version of widgetReducer)
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Widget } from './utils/utils';

interface WidgetState {
  widgets: Widget[];
}

const initialState: WidgetState = {
  widgets: [],
};

const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    deleteWidget(state, action: PayloadAction<Widget>) {
      state.widgets = state.widgets.filter(widget => widget.id !== action.payload.id);
    },
    updateWidget(state, action: PayloadAction<Widget>) {
      state.widgets = state.widgets.map(widget =>
        widget.id === action.payload.id ? action.payload : widget
      );
    },
    createWidget(state, action: PayloadAction<Omit<Widget, 'id'>>) {
      state?.widgets?.push(action.payload);
    },
    setWidgets(state, action: PayloadAction<Widget[]>) {
      state.widgets = action.payload;
    },
    updateLayout(state, action: PayloadAction<Widget[]>) {
      state.widgets = action.payload;
    },
    resetWidgets(state, action: PayloadAction<Widget[]>) {
      state.widgets = [];
    },
  },
});

export const {
  deleteWidget,
  updateWidget,
  createWidget,
  setWidgets,
  updateLayout,
  resetWidgets,
} = widgetSlice.actions;

export default widgetSlice.reducer;